export default __webpack_public_path__ + "static/media/Bracers of Vicious Frenzy.dd2e3eaf.jpg";